// components/call/CallListMiniStats.jsx
import { Flex } from "antd";
import { useEffect, useState } from "react";
import api from "../../../../api";

export default function MiniStats({ listId, refreshKey }) {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    totalTargets: 0,
    ANSWERED: 0,
    NO_ANSWER: 0,
    BUSY: 0,
    FAILED: 0,
    UNATTEMPED: 0,
  });

  useEffect(() => {
    if (!listId) return;
    setLoading(true);
    api
      .get_call_list_stats(listId)
      .then((res) => setStats(res?.data?.data || stats))
      .finally(() => setLoading(false));
  }, [listId, refreshKey]);

  return (
    <Flex vertical gap={"10px"}>
      <div
        style={{
          border: "1px solid #eee",
          borderRadius: "10px",
          padding: "10px 15px",
          backgroundColor: "#f9f9f9",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p>Нийт утасны дугаар</p>
        <p style={{ fontSize: "24px" }}>{stats.totalTargets}</p>
      </div>
      <Flex gap={"10px"}>
        <div
          style={{
            border: "1px solid #eee",
            borderRadius: "10px",
            padding: "10px 15px",
            backgroundColor: "#f9f9f9",
            width: "100%",
          }}
        >
          <p style={{ fontSize: "24px", marginBottom: "4px" }}>
            {stats.UNATTEMPED}
          </p>
          <p style={{ color: "#666", fontSize: "13px" }}>Оролдлого хийгээгүй</p>
        </div>
        <div
          style={{
            border: "1px solid #eee",
            borderRadius: "10px",
            padding: "10px 15px",
            backgroundColor: "#f9f9f9",
            width: "100%",
          }}
        >
          <p style={{ fontSize: "24px", marginBottom: "4px" }}>
            {stats.ANSWERED}
          </p>
          <p
            style={{
              color: "#666",
              fontSize: "13px",
            }}
          >
            Холбогдсон
          </p>
        </div>
        <div
          style={{
            border: "1px solid #eee",
            borderRadius: "10px",
            padding: "10px 15px",
            backgroundColor: "#f9f9f9",
            width: "100%",
          }}
        >
          <p style={{ fontSize: "24px", marginBottom: "4px" }}>
            {stats.NO_ANSWER}
          </p>
          <p style={{ color: "#666", fontSize: "13px" }}>Дуудлага аваагүй</p>
        </div>
        <div
          style={{
            border: "1px solid #eee",
            borderRadius: "10px",
            padding: "10px 15px",
            backgroundColor: "#f9f9f9",
            width: "100%",
          }}
        >
          <p style={{ fontSize: "24px", marginBottom: "4px" }}>{stats.BUSY}</p>
          <p style={{ color: "#666", fontSize: "13px" }}>Завгүй</p>
        </div>
        <div
          style={{
            border: "1px solid #eee",
            borderRadius: "10px",
            padding: "10px 15px",
            backgroundColor: "#f9f9f9",
            width: "100%",
          }}
        >
          <p style={{ fontSize: "24px", marginBottom: "4px" }}>
            {stats.FAILED}
          </p>
          <p style={{ color: "#666", fontSize: "13px" }}>Алдаатай дугаар</p>
        </div>
      </Flex>
    </Flex>
  );
}
